/**
 * WHAT: Food showcase dynamic loader
 * WHY: Load real food images into showcase grid
 * HOW: Fetch from gallery or menu items
 * IMPORTANCE: Show actual food photos instead of placeholders
 */

/**
 * Load featured food images into showcase grid
 */
async function loadFoodShowcase() {
    const foodGrid = document.getElementById('food-grid');
    if (!foodGrid) return;

    try {
        // Fetch gallery images (exclude menu-only and gallery-only from landing page)
        const response = await fetch('/api/gallery/images?activeOnly=true&excludeMenuOnly=true&excludeGalleryOnly=true');
        
        if (!response.ok) {
            console.warn('Failed to load gallery images');
            return;
        }

        const data = await response.json();
        const images = data.images || [];
        
        if (images.length === 0) {
            console.log('No gallery images available for showcase');
            return;
        }

        // Take first 3-6 images for main showcase
        const showcaseImages = images.slice(0, 6);
        
        // Clear placeholder cards
        foodGrid.innerHTML = '';
        
        // Create cards for each image
        showcaseImages.forEach((image, index) => {
            const card = createFoodCard(image, index);
            foodGrid.appendChild(card);
        });

        console.log(`Loaded ${showcaseImages.length} food images into showcase`);

        // Load additional images into extended gallery section
        const galleryGrid = document.getElementById('food-gallery-grid');
        if (galleryGrid && images.length > 6) {
            const galleryImages = images.slice(6, 18); // Next 12 images
            
            galleryImages.forEach((image, index) => {
                const card = createFoodCard(image, index + 6);
                galleryGrid.appendChild(card);
            });

            console.log(`Loaded ${galleryImages.length} additional food images into gallery`);
        }
    } catch (error) {
        console.error('Error loading food showcase:', error);
    }
}

/**
 * Create a food card element
 */
function createFoodCard(image, index) {
    const card = document.createElement('div');
    card.className = 'food-card';
    card.style.animationDelay = `${index * 0.1}s`;
    
    // Extract title from filename or use default
    const title = extractTitle(image.filename || image.title || 'Delicious Creation');
    const description = image.description || 'Handcrafted with our signature sourdough starter';
    
    card.innerHTML = `
        <div class="food-card__image-wrapper">
            <img 
                src="${image.url}" 
                alt="${title}" 
                class="food-card__image" 
                loading="lazy"
                onerror="this.src='/images/icons/no-image2.svg'"
            >
        </div>
        <div class="food-card__overlay">
            <h3 class="food-card__title">${title}</h3>
            <p class="food-card__description">${description}</p>
        </div>
    `;
    
    return card;
}

/**
 * Extract a nice title from filename
 */
function extractTitle(filename) {
    // Remove file extension and path
    let title = filename.replace(/\.[^/.]+$/, '').split('/').pop();
    
    // Remove timestamps and common prefixes
    title = title.replace(/^(image|photo|img|food)[-_]?\d*/i, '');
    title = title.replace(/[-_]\d+$/g, '');
    
    // Convert dashes/underscores to spaces and capitalize
    title = title
        .replace(/[-_]/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
        .trim();
    
    // Default if nothing left
    if (!title || title.length < 3) {
        const defaults = [
            'Artisan Sourdough',
            'Fresh Baked Goods',
            'Handcrafted Creation',
            'Baker\'s Special',
            'Daily Fresh',
            'Signature Item'
        ];
        title = defaults[Math.floor(Math.random() * defaults.length)];
    }
    
    return title;
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    if (document.body.classList.contains('home')) {
        loadFoodShowcase();
    }
});

export { loadFoodShowcase };
